import { ApiCallPayload } from '@api/api';
import { proxyApiClient } from '@api/clients';
import { useQuery } from 'react-query';

export const proxyApiCall = async (payload: ApiCallPayload) => {
  const { data } = await proxyApiClient.proxyExternalApiPost({ apiCallPayload: payload });

  return data;
};

export const useProxyApiCall = (payload: ApiCallPayload) => {
  return useQuery(['proxy-api-call', payload], () => proxyApiCall(payload));
};
